export default {"src":"/_next/static/media/logiclevelshifter.93fdbecb.svg","height":202,"width":743,"blurWidth":0,"blurHeight":0};